/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2025 (original work) Open Assessment Technologies SA ;
 */
import config from '@/config';
import { FEATURE_SCORING_PROJECTS } from '@/constants/features.js';
import { getFeaturesGuard } from '@/core/guards/featureFlagGuard.js';
import { multiGuard } from '@/core/guards/guardComposer.js';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';

const RESOURCE = 'portal.scoring-project';

function createRouteConfig(path, controller, scopes) {
    return {
        path: [path],
        controller,
        guard: multiGuard([
            getFeaturesGuard(FEATURE_SCORING_PROJECTS),
            getPermissionsGuard([{ resource: RESOURCE, scopes }])
        ])
    };
}

export const routing = [
    createRouteConfig(
        config.routes.scoringProjects.create,
        () => import('./controllers/createScoringProject.controller.js'),
        ['create']
    ),
    createRouteConfig(
        config.routes.scoringProjects.list,
        () => import('./controllers/scoringProjectsList.controller.js'),
        ['view']
    ),
    createRouteConfig(
        config.routes.scoringProjects.view,
        () => import('./controllers/scoringProjectPage.controller.js'),
        ['view']
    ),
    createRouteConfig(
        config.routes.scoringProjects.edit,
        () => import('./controllers/editScoringProject.controller.js'),
        ['edit']
    )
];
